<template>
  <div>
    <LineChart
      v-if="displaydatacollection"
      :chartData="displaydatacollection"
    />
  </div>
</template>
<script>
import axios from 'axios'
import LineChart from '@/view/components/charts/LineChart'
// import _ from 'lodash'

export default {
  name: 'trend_chart',
  components: {
    LineChart,
  },
  data() {
    return {
      reportData: null,
    }
  },
  async mounted() {
    await this.fetchData()
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      const apiUrl = process.env.VUE_APP_SERVICE_URL
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_trend`)
        .then((res) => {
          this.reportData = Object.freeze(res.data.items)
          // console.log(this.reportData)
          // mau coba pake echarts
          // convert json object to json array pake ini
          // https://stackoverflow.com/questions/31561287/how-to-convert-object-into-array-with-lodash
          // console.log(
          //   _.mapValues(this.reportData, _.partial(_.map, _, _.values))
          // )
          console.log(this.reportData)

          let testing = this.reportData.map(function (element) {
            return Object.values(element)
          })
          console.log(testing)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCharData() {
      if (this.reportData) {
        const chartData = this.reportData.map((item) => {
          return {
            name: item.day,
            capaian_harian_dosis_1: item.cumulative_capaian_harian_dosis_1,
            capaian_harian_dosis_2: item.cumulative_capaian_harian_dosis_2,
          }
        })
        // sort by completed
        chartData.sort(function (a, b) {
          return b.value - a.value
        })

        return chartData
      }
    },
  },
  computed: {
    // calling entry function
    displaydatacollection() {
      if (this.reportData) {
        const chartLabels = this.getCharData().map((item) => item.name)
        const capaian_harian_dosis_1 = this.getCharData().map(
          (item) => item.capaian_harian_dosis_1
        )
        const capaian_harian_dosis_2 = this.getCharData().map(
          (item) => item.capaian_harian_dosis_2
        )
        return {
          labels: chartLabels,
          datasets: [
            {
              label: 'Cakupan dosis 1',
              backgroundColor: 'transparent',
              data: capaian_harian_dosis_1,
              borderColor: '#36a2eb',
              borderWidth: 3,
              pointBackgroundColor: '#36a2eb',
              pointBorderColor: '#36a2eb',
              datalabels: {
                align: 'end',
                anchor: 'end',
              },
            },
            {
              label: 'Cakupan dosis 2',
              backgroundColor: 'transparent',
              data: capaian_harian_dosis_2,
              borderColor: '#13cd9d',
              borderWidth: 3,
              pointBackgroundColor: '#13cd9d',
              pointBorderColor: '#13cd9d',
              datalabels: {
                align: 'end',
                anchor: 'end',
              },
            },
          ],
        }
      }
      return false
    },
  },
}
</script>
